import {VolumeUp} from '@mui/icons-material';
import ArrMenu, {
  ArrMenuHandle,
  CustomMenuItem,
} from '../../../common/arr-menu/ArrMenu';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import {ArrAVPreviewContext} from '../arr-av-provider/ArrAVPreviewProvider';
import './ArrAudioWaveform.scss';
import {Box, Slider} from '@mui/material';
import {ArrAudioControlButton} from './ArrAudioControlButton';
import {t} from 'i18next';

const volumeItem: CustomMenuItem[] = [{id: '1', label: 'volume'}];

interface ArrAudioPaybackProps {
  onChangeVolume?: (newValue: number) => void;
}

const ArrAudioVolume: React.FC<ArrAudioPaybackProps> = ({
  onChangeVolume,
}: ArrAudioPaybackProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const menuRef1 = useRef<ArrMenuHandle | null>(null);

  const avPreviewcontext = useContext(ArrAVPreviewContext);
  const {setVolume, initVolume} = avPreviewcontext;
  const [audioVolume, setAudioVolume] = useState<number>(initVolume);

  useEffect(() => {
    setVolume(initVolume / 100);
    setAudioVolume(initVolume);
  }, [initVolume, setVolume]);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      setIsMenuOpen(!isMenuOpen);
      menuRef1.current?.open(e.currentTarget as HTMLElement);
    },
    [isMenuOpen]
  );

  const handleChange = (_: any, newValue: number) => {
    if (Array.isArray(newValue)) return;
    setAudioVolume(newValue);
    onChangeVolume?.(newValue);
    setVolume(newValue / 100);
  };

  return (
    <div data-testid="audio-volume" className="arr-audio-volume">
      <ArrAudioControlButton
        icon={<VolumeUp />}
        toolTipText={t('docMedia.volume')}
        ariaLabel={t('docMedia.volume')}
        onClick={handleClick}
      />
      <ArrMenu
        id="arr-audio-volume"
        ref={menuRef1}
        items={volumeItem}
        direction="top-right"
        className="arr-audio-volume"
        renderItem={() => {
          return (
            <Box sx={{width: 22, height: 180}}>
              <Slider
                orientation="vertical"
                value={audioVolume}
                min={0}
                max={100}
                step={1}
                onChange={handleChange}
                valueLabelDisplay="auto"
                aria-label={t('docMedia.volume')}
                aria-valuetext={`${audioVolume}%`}
              />
            </Box>
          );
        }}
        onClose={() => setIsMenuOpen(false)}
      />
    </div>
  );
};

export {ArrAudioVolume};
